class holidayGroup{
    constructor(
        id,
        name
      ) {
      this.id = id;
      this.name = name;
    }
    static fromJson({
        tipoFerId,
        nombre
    }) {
      return new holidayGroup(
        tipoFerId,
        nombre
      );
    }
  }
  export default holidayGroup;
  